import InboxTeamsAPI from '../../api/inboxTeams';

const state = {
  records: [],
};

export const getters = {
  getInboxTeams($state) {
    return $state.records;
  },
};

export const mutations = {
  SET_INBOX_TEAMS($state, teams) {
    $state.records = teams;
  },
  CLEAR_INBOX_TEAMS($state) {
    $state.records = [];
  },
};

export const actions = {
  async get({ commit }, { inboxId }) {
    const response = await InboxTeamsAPI.show(inboxId);
    commit('SET_INBOX_TEAMS', response.data.payload);
    return response;
  },
  create(_, { inboxId, teamList }) {
    return InboxTeamsAPI.update({ inboxId, teamList });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
